// Token管理
const TOKEN_KEY = 'furniture_shop_token';
const USER_INFO_KEY = 'furniture_shop_user';

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// 用户信息管理
export const getUserInfo = () => {
  const userStr = localStorage.getItem(USER_INFO_KEY);
  return userStr ? JSON.parse(userStr) : null;
};

export const setUserInfo = (userInfo) => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo));
};

export const removeUserInfo = () => {
  localStorage.removeItem(USER_INFO_KEY);
};

// 更新用户信息
export const updateUserInfo = (updates) => {
  const currentUser = getUserInfo();
  if (currentUser) {
    const updatedUser = { ...currentUser, ...updates };
    setUserInfo(updatedUser);
    return updatedUser;
  }
  return null;
};
